const STORAGE_KEY = 'smarpanel';
const LEGACY_STORAGE_KEY = 'smar';
const SHARED_PARENT_DOMAIN = 'smarapd.com.br';
const COOKIE_MAX_AGE_SECONDS = 400 * 24 * 60 * 60;

export const SMARPANEL_FLAG_CHANGED_EVENT = 'smarpanel-flag-changed';

function notifySmarPanelFlagChange(enabled) {
  window.dispatchEvent(
    new CustomEvent(SMARPANEL_FLAG_CHANGED_EVENT, { detail: { enabled } })
  );
}

function parseStoredValue(rawValue) {
  if (rawValue === null) return null;
  return rawValue === 'true';
}

function resolveSharedCookieDomain(hostname = window.location.hostname) {
  if (
    hostname === SHARED_PARENT_DOMAIN ||
    hostname.endsWith(`.${SHARED_PARENT_DOMAIN}`)
  ) {
    return SHARED_PARENT_DOMAIN;
  }

  return null;
}

function buildCookieSuffix({ maxAge, domain }) {
  const parts = [`Path=/`, `Max-Age=${maxAge}`, 'SameSite=Lax'];

  if (domain) {
    parts.push(`Domain=${domain}`);
  }

  if (window.location.protocol === 'https:') {
    parts.push('Secure');
  }

  return parts.join('; ');
}

function readCookie(name) {
  const prefix = `${name}=`;
  const cookies = document.cookie.split(';');

  for (let i = 0; i < cookies.length; i += 1) {
    const cookie = cookies[i].trim();
    if (cookie.startsWith(prefix)) {
      return decodeURIComponent(cookie.slice(prefix.length));
    }
  }

  return null;
}

function writeCookie(name, value, maxAge = COOKIE_MAX_AGE_SECONDS) {
  const domain = resolveSharedCookieDomain();
  const encoded = encodeURIComponent(value);
  document.cookie = `${name}=${encoded}; ${buildCookieSuffix({
    maxAge,
    domain,
  })}`;
}

function readLegacyLocalStorage() {
  const current = localStorage.getItem(STORAGE_KEY);
  if (current !== null) return current;

  const legacy = localStorage.getItem(LEGACY_STORAGE_KEY);
  if (legacy !== null) return legacy;

  return null;
}

function clearLegacyLocalStorage() {
  localStorage.removeItem(STORAGE_KEY);
  localStorage.removeItem(LEGACY_STORAGE_KEY);
}

function readStorageValue() {
  const cookieValue = readCookie(STORAGE_KEY);
  if (cookieValue !== null) return cookieValue;

  const legacyValue = readLegacyLocalStorage();
  if (legacyValue !== null) {
    writeCookie(STORAGE_KEY, legacyValue);
    clearLegacyLocalStorage();
    return legacyValue;
  }

  return null;
}

/**
 * Lê a flag do SmarPanel no cookie compartilhado (*.smarapd.com.br).
 * Retorna null se a chave ainda não existir.
 */
export function getSmarPanelFlag() {
  return parseStoredValue(readStorageValue());
}

/**
 * Indica se o SmarPanel está habilitado.
 * Retorna false quando a chave não existe.
 */
export function isSmarPanelEnabled() {
  return getSmarPanelFlag() === true;
}

export function setSmarPanelFlag(enabled) {
  writeCookie(STORAGE_KEY, enabled ? 'true' : 'false');
  clearLegacyLocalStorage();
  notifySmarPanelFlagChange(enabled);
}

/**
 * Na primeira visita à rota /smar cria a chave já ativada.
 * Se já existir, preserva o valor e renova o cookie compartilhado.
 */
export function ensureSmarPanelFlagOnVisit() {
  const current = readStorageValue();

  if (current === null) {
    setSmarPanelFlag(true);
    return true;
  }

  const enabled = parseStoredValue(current) === true;
  writeCookie(STORAGE_KEY, enabled ? 'true' : 'false');
  return enabled;
}
